export const initialState = {
    hasVideo: true,
    hasAudio: true,
};
export default function localMediaReducer(state = initialState, { type, payload } = {}) {
    switch (type) {
        case 'LOCAL_MEDIA/SET_VIDEO_STATE':
            return { ...state, hasVideo: payload };
        case 'LOCAL_MEDIA/SET_AUDIO_STATE':
            return { ...state, hasAudio: payload };
        case 'LOCAL_MEDIA/SET_MEDIA_STATE':
            return { ...state, ...payload };
        default:
            return state;
    }
}
